export default __webpack_public_path__ + "static/media/product-pc-3.f0be19b1.png";